import { BigNumber } from "@ethersproject/bignumber"

import { useAddress } from "web3/hooks/useAddress"
import { useMe } from "user/providers/MeProvider"
import { useProposalThresholdRequirementQuery } from "query/graphql"
import type { Governor } from "query/graphql"

export const useProposalThresholdRequirement = (
  governance?: Governor | null,
): {
  isProposalThresholdMet: boolean | undefined
  isLoading: boolean
  proposalThreshold?: string
  delegatedVotingPower: BigNumber
} => {
  const me = useMe()
  const address = useAddress()

  const proposalThreshold =
    governance?.parameters.proposalThreshold ?? undefined

  const addressToQuery =
    me?.type === "SAFE" && me?.address ? me.address : address

  const { data: proposalThresholdData, isLoading: isProposalThresholdLoading } =
    useProposalThresholdRequirementQuery(
      {
        governorId: (governance as Governor).id,
        address: addressToQuery as string,
      },
      {
        enabled: Boolean(addressToQuery && governance),
      },
    )

  const delegatedVotingPower = !proposalThresholdData?.delegate
    ? BigNumber.from(0)
    : BigNumber.from(proposalThresholdData.delegate.votesCount)

  const isProposalThresholdMet =
    Boolean(proposalThreshold) &&
    Boolean(delegatedVotingPower) &&
    !isProposalThresholdLoading
      ? BigNumber.from(delegatedVotingPower).gte(proposalThreshold ?? "0")
      : undefined

  const isLoading = !delegatedVotingPower && !proposalThreshold

  return {
    isLoading,
    proposalThreshold,
    delegatedVotingPower,
    isProposalThresholdMet,
  }
}
